<script setup>
import { ref, watch } from "vue";
import _cloneDeep from "lodash/cloneDeep";
import CategoryPreview from "./CategoryPreview.vue";
import { CircleCheckIcon, CircleSlashIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { reorderCategories } from "@Pages/OneClick/utils";

const categories = defineModel("categories");

defineProps({
    localCategories: {
        type: Array,
        default: [],
    },
});

defineEmits(["deleteCategory"]);

const { t: __ } = useI18n();
const _categories = ref([]);

watch(
    categories,
    (newCategories) => {
        // reorder categories to match the tree structure
        _categories.value = reorderCategories(_cloneDeep(newCategories));
    },
    { deep: true, immediate: true }
);
</script>
<template>
    <div class="bg-white rounded divide-y divide-gray-100 ring-1 ring-gray-300 dark:bg-gray-900 dark:divide-gray-800 dark:ring-gray-800">
        <div class="flex items-center px-3 py-2">
            <div :class="['text-sm font-medium', categories.length > 0 ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-400']">
                {{ __("Catégories") }}
            </div>
            <CircleCheckIcon v-if="categories.length > 0" class="size-4 ml-3 text-gray-900 dark:text-white" />
            <CircleSlashIcon v-else class="size-4 ml-3 text-gray-600 dark:text-gray-400" />
        </div>
        <div v-if="categories.length > 0" class="px-3 py-2 space-y-1">
            <template v-for="_category in _categories" :key="_category.index">
                <CategoryPreview
                    v-model:category="categories[_category.index]"
                    @deleteCategory="$emit('deleteCategory', _category.index)"
                    :local-categories="localCategories"
                    :depth="_category.depth" />
            </template>
        </div>
    </div>
</template>
